import { render, staticRenderFns } from "./ExpenseEditing.vue?vue&type=template&id=5423048b&scoped=true"
import script from "./ExpenseEditing.vue?vue&type=script&lang=js"
export * from "./ExpenseEditing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5423048b",
  null
  
)

export default component.exports